<template>
  <v-autocomplete
    ref="input"
    v-bind="attributes"
    v-on="$listeners"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "z-autocomplete",

  computed: {
    attributes() {
      return { ...this.$attrs, ...this.$v.TEXT_FIELDS };
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
